import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CabalasContentDataSource } from './cabalas-content-data-source';
import { CabalaEntry } from '../../../modules/cabalas/models/cabala.model';

/**
 * JSON file-based cábalas content data source.
 * Reads from /content/cabalas/*.json files.
 */
@Injectable()
export class JsonCabalasContentDataSource extends CabalasContentDataSource {
  private readonly basePath = '/content/cabalas';

  constructor(private readonly http: HttpClient) {
    super();
  }

  getEntries(slug: string): Observable<CabalaEntry[]> {
    return this.http.get<CabalaEntry[]>(`${this.basePath}/${slug}.json`);
  }
}
